/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 function ThemeCustom ( ){

    var options = {
        decreaseQuantitySelector: '[data-action="decrease-quantity"]',
        increaseQuantitySelector: '[data-action="increase-quantity"]'
    };

    var cache = {
        decreaseQuantity: $(options.decreaseQuantitySelector),
        increaseQuantity: $(options.increaseQuantitySelector)
    };

    console.log( cache );

    var checkForMinimum = function (event, element) {

        var $button = $(element),
            $input = $button.next('.quantity-selector__value');

        console.log( 'button: ', $button );
        console.log( 'input: ', $input );
        console.log( 'value: ', $input.val() );
        console.log( 'data: ', $button.data('minimum') );

        if ( $button.data('minimum') ){

            var $val = parseInt($input.val()),
                $min = parseInt($button.data('minimum'));

            if( $val <= $min ){
                
                event.stopImmediatePropagation();
            };
        };
    };

    this.listeners = function () {

        console.log( 'run listeners' );

        $(document).on('click', options.decreaseQuantitySelector, function (event){

            console.log( 'decreaseQuantity' );

            checkForMinimum(event, $(this));
        });
    };

    this.init = function (){

        console.log( 'initialize' );

        this.listeners();
    };

    this.init();
}

// ThemeCustom();